import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { get } from 'lodash';

import { AddressVerificationContainer, AddressVerificationContainerInner } from '../styles';
import { AppDispatch, IStore } from '../../../../store.type';
import {
  changeRfiSgKYCScreen,
  fetchData,
  setSelectedAddressDoc
} from '@Redux/actions/rfi/rfi-action';
import { API_URL } from '@Utils/config';
import { VerificationMethod } from '../../../user-flow/individual/revampedUserFlow/styles';
import {
  CHEVRON_RIGHT_ICON,
  DRIVING_LICENSE_ICON,
  PIGGY_BANK_ICON,
  REPORT_BILL_ICON
} from '@Images';
import { FORMNAME_RFI, INDIVIDUAL_POA, SG } from '@Utils/constants';
import { getSgkycFlowRfiData } from '@Redux/selectors';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import { SG_ODD_FLOW_TYPES, SG_ODD_SCREEN_NAMES } from '../ScreenConstants';
import { DocumentObject, DocumentOption, NestedField, RadioOptionValue } from '../types';
import { POA_UPLOAD_PAGE } from '../utils';
import { getIndividualDocumentsUploadList } from '@Redux/actions/onboarding/new-onboarding-action';

export const PoaUploadPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [documentList, setDocumentList] = useState([]);
  const getAllformVal = useSelector((state: IStore) => getFormValues(FORMNAME_RFI)(state) || {});
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const selectedFlowType = sgKycFlowData?.selectedFlowType;
  const isSingpassFlow = selectedFlowType === SG_ODD_FLOW_TYPES.SINGPASS;
  const personalInfoNestedFieldsJson = sgKycFlowData?.renderingObject?.values?.find(
    (item: DocumentOption) => item.code === 'MANUAL'
  )?.nested_fields_json;
  const permanentSgResidentValues = personalInfoNestedFieldsJson?.find(
    (item: NestedField) => item.name === 'is_permanent_sg_resident'
  )?.values;
  const documentListUrl =
    permanentSgResidentValues?.find((item: RadioOptionValue) => item.label === 'No')?.values?.[0]
      ?.url || null;
  const { heading, description } = POA_UPLOAD_PAGE;

  const fetchDocList = async (documentListUrl: string) => {
    if (documentListUrl) {
      dispatch(activateLoader());
      const radioFieldName = sgKycFlowData?.rfiDetails?.fields_json?.[0]?.field_name || '';
      const nationality = String(
        get(getAllformVal, radioFieldName?.replace(/\.[^.]+$/, '.nationality'), '')
      );
      const isPermanentSGResident = get(
        getAllformVal,
        radioFieldName?.replace(/\.[^.]+$/, '.is_permanent_sg_resident'),
        false
      );
      const data = await dispatch(
        fetchData(API_URL, documentListUrl, {
          nationality: nationality || SG,
          ...(isPermanentSGResident || nationality !== SG
            ? { is_permanent_sg_resident: isPermanentSGResident }
            : {})
        })
      );
      if (data?.response?.status === 462) {
        // In case of error redirect user to personal_info page
        dispatch(changeRfiSgKYCScreen(SG_ODD_SCREEN_NAMES.personal_info_page));
        return;
      }
      const poaDocList = data?.filter((doc: DocumentObject) => doc.type === INDIVIDUAL_POA) || [];
      setDocumentList(poaDocList);
      dispatch(disableLoader());
    }
  };
  const fetchsubmitPOADocList = async () => {
    dispatch(activateLoader());
    const data = await dispatch(getIndividualDocumentsUploadList());
    const poaDocList = data?.filter((doc: DocumentObject) => doc.type === INDIVIDUAL_POA) || [];
    setDocumentList(poaDocList);
    dispatch(disableLoader());
  };

  useEffect(() => {
    if (isSingpassFlow) fetchsubmitPOADocList();
  }, [isSingpassFlow]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isSingpassFlow && documentListUrl) fetchDocList(documentListUrl);
  }, [documentListUrl, isSingpassFlow]); //eslint-disable-line react-hooks/exhaustive-deps

  const getMappedImage = (documentCode: string) => {
    switch (documentCode) {
      case 'DRIVING_LICENSE':
        return DRIVING_LICENSE_ICON;
      case 'BANK_STATEMENT':
        return PIGGY_BANK_ICON;
      case 'UTILITY_BILL':
        return REPORT_BILL_ICON;
      default:
        return DRIVING_LICENSE_ICON;
    }
  };

  return (
    <AddressVerificationContainer>
      <div className="heading">{heading}</div>
      <div className="subHeading">{description}</div>

      <AddressVerificationContainerInner>
        {documentList?.map((doc, index) => {
          const { document_code, label, document_description } = doc;
          return (
            <VerificationMethod
              onClick={() => {
                dispatch(setSelectedAddressDoc(doc));
                dispatch(changeRfiSgKYCScreen(SG_ODD_SCREEN_NAMES.poa_selected_upload_page));
              }}
              key={index}
            >
              <div className="image-container">
                <img src={getMappedImage(document_code)} alt={label} />
              </div>
              <div className="mid-section-container">
                <span className="main-text">{label}</span>
                <span className="sub-text">{document_description}</span>
              </div>

              <div className="verification-method-right-icon">
                <img src={CHEVRON_RIGHT_ICON} alt="chevron-right" />
              </div>
            </VerificationMethod>
          );
        })}
      </AddressVerificationContainerInner>
    </AddressVerificationContainer>
  );
};
